<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head">
				<div class="modal__head__title">How would you like to Pay?</div>
				<!-- <div class="modal__head__subtitle">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam, sed!</div> -->
			</div>
			<div class="modal__content">
            	<button class="btn btn-small" @click="emitPayByBacs">Via BACS Transfer</button>
            	<button class="btn btn-small primary pay-by-card" @click="emitPayByCard">Securely via Credit/Debit Card</button>
			</div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		props : [],
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'PayNowModal',
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		},
		methods : {
			emitPayByCard(){
				this.$store.commit('openModal', '');
				this.$emit('payByCard');
            },
            emitPayByBacs(){
                this.$store.commit('openModal', '');
                this.$emit('payByBacs');
                
            }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/PayNowModal.vue